import { Skeleton } from 'components/common/skeleton';

import './SkeletonMobileRoom.css';
const SkeletonMobileRoom = () => {
    return (
        <div className="ab-room-row">
            <div className="ab-room-row-main ab-flex-column">
                <div className="ab-room-image-container">
                    <div className="ab-room-image">
                        <Skeleton width={'100%'} height={120} />
                    </div>
                </div>
                <div className="ab-room-middle-container">
                    <div className="ab-room-middle-upper">
                        <div className="ab-room-upper-head">
                            <div className="ab-room-upper-name">
                                <Skeleton width={'45%'} height={24} />
                            </div>

                            <div className="ab-prices-buttons-mobile-room-skeleton">
                                <div className="ab-prices-buttons-left">
                                    <div>
                                        <Skeleton width={'100%'} height={24} />
                                    </div>

                                    <div
                                        className="ab-price"
                                        tabIndex="0"
                                        role="button"
                                    >
                                        <Skeleton width={'100%'} height={24} />
                                        <div className="ab-original-price">
                                            <Skeleton
                                                width={'100%'}
                                                height={24}
                                            />
                                        </div>
                                    </div>
                                    <div className="ab-freebies">
                                        <div className="ab-freebie">
                                            <div className="ab-cancel-policy-text">
                                                {
                                                    <Skeleton
                                                        width={'100%'}
                                                        height={24}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ab-prices-buttons-right">
                                    <div className="ab-room-upper-occupancy">
                                        <Skeleton
                                            width={'100%'}
                                            height={12}
                                            mb={10}
                                        />
                                    </div>
                                    <Skeleton
                                        width={'100%'}
                                        height={30}
                                        mb={8}
                                    />
                                    <Skeleton
                                        width={'100%'}
                                        height={30}
                                        mb={8}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ab-room-middle-footer">
                        <div
                            className="ab-expand-options"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <Skeleton width={'60%'} height={24} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonMobileRoom;
